export const islt = {
    data: {
        vertical: {
            car: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/islt/images/iselect-car-insurance.svg',
                    header_logo_image_url_small: '/evt/assets/brand/islt/images/iselect.svg',
                    error_page_quote_something_went_wrong_image_url: 'https://www.iselect.com.au/wp-content/themes/iselect/assets/images/404-oops.webp',
                    quote_expired_screen_image_url: null,
                    rego_lookup_loading_screen_hero_image_url: null,
                    welcome_back_hero_image_url: null,
                    price_confidence_banner_mobile_url: null,
                    price_confidence_banner_tablet_url: null,
                    price_confidence_banner_desktop_url: null
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: '/evt/assets/car-insurance/brand/islt/pdf/privacy_policy.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://www.iselect.com.au/general-insurance-financial-services-guide',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://www.iselect.com.au/terms-and-conditions/',
                    footer_disclaimer_how_comparison_works_url: null,
                    footer_disclaimer_financial_services_guide_url: 'https://www.iselect.com.au/wp-content/uploads/FSG/car-home-comparison-FSG.pdf',
                    footer_disclaimer_terms_of_use_url: 'https://www.iselect.com.au/terms-and-conditions/',
                    footer_copyright_banner_privacy_policy_url: '/evt/assets/car-insurance/brand/islt/pdf/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://www.iselect.com.au/terms-and-conditions/',
                    header_logo_image_link: 'https://iselect.com.au/'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'iSelect',
                    application_details_opt_in_checkbox_brand_name: 'iSelect',
                    rego_lookup_licence_plate_placeholder: '123ISLT',
                    rego_lookup_default_licence_plate_state_label: 'iSelect',
                    rego_lookup_welcome_message: "Welcome to iSelect. We're here to help you find a great deal on car insurance."
                }
            },
            home: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/islt/images/iselect-home-contents.svg',
                    header_logo_image_url_small: '/evt/assets/brand/islt/images/iselect.svg',
                    error_page_quote_something_went_wrong_image_url: 'https://www.iselect.com.au/wp-content/themes/iselect/assets/images/404-oops.webp',
                    shielded_thank_you_hero_image_url: null,
                    welcome_back_hero_image_url: null,
                    price_confidence_banner_mobile_url: null,
                    price_confidence_banner_tablet_url: null,
                    price_confidence_banner_desktop_url: null
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: '/evt/assets/home-contents-insurance/brand/islt/pdf/privacy_policy.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://www.iselect.com.au/general-insurance-financial-services-guide/',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://www.iselect.com.au/terms-and-conditions/',
                    footer_disclaimer_how_comparison_works_url: null,
                    footer_disclaimer_financial_services_guide_url: 'https://www.iselect.com.au/wp-content/uploads/FSG/car-home-comparison-FSG.pdf',
                    footer_disclaimer_terms_of_use_url: 'https://www.iselect.com.au/terms-and-conditions/',
                    footer_copyright_banner_privacy_policy_url: '/evt/assets/home-contents-insurance/brand/islt/pdf/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://www.iselect.com.au/terms-and-conditions/',
                    header_logo_image_link: 'https://iselect.com.au/'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'iSelect',
                    application_details_opt_in_checkbox_brand_name: 'iSelect'
                }
            }
        },
        design_system: {
            everest: {
                brand_primary: '#4D4D4D',
                brand_secondary: '#FF6200',
                brand_base: '#464646',
                feature_1: '#4D4D4D',
                feature_2: '#FF6200',
                feature_3: '#EF5123',
                feature_4: '#DD3A32',
                brand_primary_120: '#262626',
                brand_primary_80: '#6D6D6D',
                brand_primary_60: '#999999',
                brand_primary_30: '#E7E7E7',
                brand_primary_10: '#F6F6F6',
                brand_secondary_120: '#DB5400',
                brand_secondary_80: '#FF8133',
                brand_secondary_60: '#FFA166',
                brand_secondary_30: '#FFE0CC',
                brand_secondary_10: '#FFEFE5',
                brand_base_120: '#262626',
                brand_base_80: '#6D6D6D',
                brand_base_60: '#999999',
                brand_base_20: '#E7E7E7',
                brand_base_10: '#F6F6F6',
                brand_base_0: '#FFFFFF',
                feature_1_120: '#262626',
                feature_1_80: '#FDC113',
                feature_1_60: '#FEF295',
                feature_1_30: '#FEF5AF',
                feature_1_10: '#FFF9CA',
                feature_2_120: '#DB5400',
                feature_2_80: '#FF8133',
                feature_2_60: '#FFA166',
                feature_2_30: '#FFE0CC',
                feature_2_10: '#FFEFE5',
                feature_3_120: '#EB2500',
                feature_3_80: '#F2744F',
                feature_3_60: '#F5977B',
                feature_3_30: '#FACBBD',
                feature_3_10: '#FDEEE9',
                feature_4_120: '#B3261E',
                feature_4_80: '#E56C66',
                feature_4_60: '#ED9B96',
                feature_4_30: '#F6CDCB',
                feature_4_10: '#FDE6E5',
                body_color: '#464646',
                body_background_color: '#FFFFFF',
                validation_error_color: '#B3261E',
                validation_error_bg_color: '#FBE6E5',
                validation_success_color: '#FF6200',
                form_label_color: '#4D4D4D',
                color_border_default: '#E7E7E7',
                color_border_input_default: '#6D6D6D',
                modal_overlay_dark: 'rgba(0, 0, 0, 0.7)',
                modal_overlay_light: 'rgba(255, 255, 255, 0.3)',
                family_base: 'Proxima Nova, Helvetica, Arial, sans-serif',
                family_heading: 'Toroka, Helvetica, Arial, sans-serif',
                medicare_green: '#b9f79e',
                medicare_blue: '#d4eef5',
                medicare_yellow: '#f7e97b',
                energy_secondary_button: '#0ec228',
                energy_secondary_button_120: '#0ea324',
                energy_primary_button: '#0ec228',
                energy_primary_button_120: '#0ea324',
                result_hint_yellow: '#f0e599',
                energy_feature_blue: '#001443',
                energy_label_highlight_blue: '#e7f2fd',
                a_link: '#FF6200',
                input_border_radius: '0px',
                next_button_border_radius: '1rem',
                handover_button_border_radius: '1rem',
                progress_bar_inactive: '#E7E7E7',
                progress_bar_active: '#FF6200',
                registration_number_border_color: '#FF6200',
                radio_input_color: '#FF6200', // radio filter button results page
                radio_icon_color: '#FF6200', // radio group icon color,
                call_options_icon_inactive: '#FF6200',
                call_options_icon_active: '#FF6200',
                background_theme_color: '#FF6200',
                font_40: '4rem',
                font_32: '3.2rem',
                font_24: '2.4rem',
                font_20: '2rem',
                font_18: '1.8rem',
                font_16: '1.5rem',
                font_14: '1.4rem',
                font_12: '1.2rem',
                font_10: '1rem'
            }
        }
    }
};
